module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_green.cb6d2fa9.svg";